module.exports = __webpack_public_path__ + "img/file-arrow-up-fill.a2332032.svg";